import createReducer from './reducerUtils'
import { LOAD_CAMPANIAS, LOADING_CAMPANIAS, LOADING_NOTIFICACION_SECTORISTA } from '../actions/actionTypes'

const initialState = {
  campanias: [],
  loadingCampanias: false,
  loadingNotificacionSectorista: false
}


const loadCampanias = (state, payload) => {
  return {
    ...state,
    campanias: payload.campanias,
  }
}

const loadingCampanias = (state, payload) => {
  return { ...state, loadingCampanias: payload.loading }
}

const loadingNotificacionSectorista = (state, payload) => {
  return { ...state, loadingNotificacionSectorista: payload.loading }
}


export default createReducer(initialState, {
  [LOAD_CAMPANIAS]: loadCampanias,
  [LOADING_CAMPANIAS]: loadingCampanias,
  [LOADING_NOTIFICACION_SECTORISTA]: loadingNotificacionSectorista
})
